<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template(v-if="settings.withTime && settings.showTime && parametersFrom === 'homework'")
						| {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}:
						| {{ settings.showTime }}
						| {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
						br
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') }}:
								| {{ $i18n.t('couples.couples_view_' + settings.leftColumn) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeRight') }}:
								| {{ $i18n.t('couples.couples_view_' + settings.rightColumn) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}:
								| {{ settings.amountOfPairs }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
								| {{ settings.numOfExamples }}
						br
						span(v-if='!settings.withTime')
								| {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}:
								| {{ $i18n.t('couples.couples_gameMode_' + settings.mode) }}
						br
						span(v-if="settings.leftColumn === 'word' || settings.rightColumn === 'word'")
								| {{ $i18n.t('trainer.trainer_gameFormSetting_difficultWords') }}:
								template(v-if='settings.difficultWords')
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
								template(v-else)
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
